import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';

import Core from './../../../Core/Core';
import Exporter from './../../../Core/Exporter';
import Header from './../../Header';
import FlashForm from './../../Flash/FlashForm';
import { formatPercent, formatEuro } from './../../DataGrid/Format';

import ErrorBoundary from '../ErrorBoundary';
import ErrorManager from './../../../Core/ErrorManager';

class Flash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flashs: [],
      flash: {},
    };

    this.load = this.load.bind(this);
    this.submit = this.submit.bind(this);
    this.handleRedux = this.handleRedux.bind(this);

    this.checkPermisions();
    this.load();
  }

  checkPermisions() {
    let user = JSON.parse(localStorage.getItem('User'));
    if (user && user.email) {
      Core.Instance.Request(Core.Address + 'GetUserFromEmail/?email=' + user.email, null, 'GET').then((json) => {
        if (!json[0].flash_access) {
          window.location.href = '/search';
        }
      });
    }
  }

  load() {
    Core.Instance.Request(Core.Address + 'Flash/?by=model&order=asc', null, 'GET').then((json) => {
      this.setState({
        flashs: json != null ? json : [],
      });
    });
  }

  componentDidMount() {
    document.title = 'W-F: Liste des flashs';
  }

  handleRedux(event) {
    let flash = this.state.flash;
    flash[event.target.name] = event.target.value;
    this.setState({
      flash: flash,
    });
  }

  submit() {
    if (Object.getOwnPropertyNames(this.state.flash).length <= 0) {
      ErrorManager.Instance.Handle('Vous devez remplir le formulaire avant de pouvoir enregistrer.');
      return;
    }

    if (!Core.Instance.CheckForm(this)) return;
    let flash = this.state.flash;
    let request = null;
    request = Core.Instance.Request(Core.Address + 'Flash', flash, 'POST');
    request.then((json) => {
      ErrorManager.Instance.Info('Les modifications ont bien été enregistrées.');
      window.location.reload();
    });
  }

  deleteRow = (Flash_id) => {
    Core.Instance.Request(Core.Address + 'Flash/' + Flash_id, null, 'DELETE').then((json) => {
      ErrorManager.Instance.Info("L'élément a bien été supprimé.");
      window.location.reload();
    });
  };

  onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    this.setState(
      (state) => {
        const flashs = state.flashs.slice();
        for (let i = fromRow; i <= toRow; i++) {
          flashs[i] = { ...flashs[i], ...updated };
        }
        return { flashs };
      },
      () => {
        Core.Instance.Request(Core.Address + 'UpdateFlash/', this.state.flashs[fromRow], 'PUT').then((json) => {});
      },
    );
  };

  getCellActions = (column, row) => {
    const cellActions = {
      delete: [
        {
          icon: <span className='far fa-trash-alt' />,
          callback: () => {
            this.deleteRow(row.id);
          },
        },
      ],
    };
    return cellActions[column.key];
  };

  render() {
    const columns = [
      { key: 'model', name: 'Modèle', width: 250, editable: true },
      { key: 'margin', name: 'Marge', editable: true, formatter: formatPercent },
      { key: 'bmod', name: 'BMOD', editable: true, formatter: formatPercent },
      { key: 'takeover', name: 'Reprise', editable: true, formatter: formatEuro },
      { key: 'takeover_twelve', name: 'Reprise > 12 ans', editable: true, formatter: formatEuro },
      { key: 'takeover_conquest', name: 'Reprise conquête', editable: true, formatter: formatEuro },
      { key: 'takeover_loyalty', name: 'Reprise fidé', editable: true, formatter: formatEuro },
      { key: 'booster', name: 'Booster commandes immat', width: 200, editable: true, formatter: formatEuro },
      { key: 'destocking', name: 'Destock', editable: true, formatter: formatEuro },
      { key: 'pool', name: 'Pool', editable: true, formatter: formatEuro },
      { key: 'test_park', name: 'Parc essai', editable: true, formatter: formatPercent },
      { key: 'so', name: 'SO', editable: true, formatter: formatPercent },
      { key: 'delete', name: ''},
    ];

    return (
      <ErrorBoundary>
        <Header />
        <div className='container-fluid Flash'>
          <div className='row'>
            <div className='col'>
              <div className='card m-3 p-3'>
                <div className="card-body">
                  <div className="card-title mb-4">
                    <span className='h4 align-middle'>Flashs</span>
                    <span className="float-right mr-2" >
                        <a href="#" onClick={ () => {Exporter.Instance.ExportCSV('Flash');} }><li className='fas fa-file-export'></li> <u>Exporter</u></a>    
                    </span>
                    <span className="float-right mr-3" data-toggle="modal" data-target="#addFlashModal">
                        <a href="#"><li className='fas fa-plus'></li> <u>Ajouter un flash</u></a>    
                    </span>       
                  </div>
                  <div id='flashs' className='collapse show'>
                    <ReactDataGrid
                      className=''
                      columns={columns}
                      rowGetter={(i) => this.state.flashs[i]}
                      rowsCount={this.state.flashs.length + 1}
                      onGridRowsUpdated={this.onGridRowsUpdated}
                      enableCellSelect={true}
                      rowHeight={50}
                      headerRowHeight={60}
                      minHeight={700}
                      getCellActions={this.getCellActions}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FlashForm flash={this.state.flash} onChange={this.handleRedux} onSubmit={this.submit}/>
        </div>
      </ErrorBoundary>
    );
  }
}

export default Flash;



// WEBPACK FOOTER //
// ./src/Components/Views/Flash/Flash.js